import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import './plugins/bootstrap-vue'
import VueSelect from './plugins/vue-select'
import './plugins/vue-toasted'
import { createVfm } from 'vue-final-modal'
import './plugins/vue-draggable'
import './plugins/sentry'
import './plugins/v-calendar'
import veeValidate from './plugins/vee-validate'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import 'vue-select/dist/vue-select.css'
import './assets/styles/modal.css'
import ToastPlugin from './plugins/vue-toastification'
import 'v-calendar/style.css'

// Import Bootstrap and Bootstrap Vue Next
// import Bootstrap from 'bootstrap-vue-next'

// Import CSS files
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import VCalendar from 'v-calendar'

const app = createApp(App)

// Initialize store and router first
app.use(store)
app.use(router)

// Then initialize other plugins
const vfm = createVfm({
  componentName: 'VueFinalModal',
  key: 'vfm',
  dynamicContainerName: 'ModalsContainer',
  defaultModelValue: false,
  defaultClickToClose: true,
  defaultEscToClose: true,
  defaultLockScroll: true,
  defaultHideOverlay: false,
  defaultOverlayClass: 'vfm__overlay',
  defaultContentClass: 'vfm__content'
})

app.use(VueSelect)
app.use(vfm)
app.use(veeValidate)
app.use(ToastPlugin)
app.use(VCalendar, {})

app.directive('validate', {
  mounted (el, binding) {
    return true
  }
})

app.mount('#app')

export { app }
